import HeaderBlog from './Headers/HeaderBlog.js';
import FooterBlog from '../components/Footers/FooterBlog.js';
import '../styles/Blog.scss';
import articleImg from '../images/articleImg.png';
import calendar from '../images/calendar.png';
import comment from '../images/comment.png';
import person from '../images/person.png';

function Blog() {
    return (
        <div className = "Blog">
            <HeaderBlog/> 

                <div id = "headerContactImg">
                    <span>Blog</span>
                </div>

                <div className = "articles">
                    <img src = {articleImg}></img>
                    <img src = {calendar}></img>
                    <span>21 Jun 2022</span>
                    <img src = {comment}></img>
                    <span>5</span>
                    <img src = {person}></img>
                    <span>Chef Michael Carter</span>

                    <p>5 Secrets Behind Our Most Popular Dishes</p>

                    <p>
                        Discover what makes our dishes so special. From fresh ingredients to unique recipes,
                        we share the secrets that keep our customers coming back for more.
                    </p>

                    <span>Read More</span>
                </div>

                <div className = "articles">
                    <img src = {articleImg}></img>
                    <img src = {calendar}></img>
                    <span>21 Jun 2022</span>
                    <img src = {comment}></img>
                    <span>5</span>
                    <img src = {person}></img>
                    <span>Chef Michael Carter</span>

                    <p>How We Choose Our Ingredients</p>

                    <p>
                        Quality starts with ingredients. Learn how we select fresh, local products
                        to create meals that taste better and feel better.
                    </p>

                    <span>Read More</span>
                </div>

                <div className = "articles">
                    <img src = {articleImg}></img>
                    <img src = {calendar}></img>
                    <span>21 Jun 2022</span>
                    <img src = {comment}></img>
                    <span>5</span>
                    <img src = {person}></img>
                    <span>Chef Michael Carter</span>

                    <p>Top 5 Meals You Must Try</p>

                    <p>
                        Not sure what to order? Here are our customer favorites that never disappoint.
                        Perfect for your first visit or your next craving.
                    </p>

                    <span>Read More</span>
                </div>

                <div className = "articles">
                    <img src = {articleImg}></img>
                    <img src = {calendar}></img>
                    <span>21 Jun 2022</span>
                    <img src = {comment}></img>
                    <span>5</span>
                    <img src = {person}></img>
                    <span>Chef Michael Carter</span>

                    <p>Behind The Scenes In Our Kitchen</p>

                    <p>
                        Take a look at how our chefs prepare every dish with passion, precision and care.
                        From prep to plate – quality at every step.
                    </p>    

                    <span>Read More</span>
                </div>

                <div className = "articles">
                    <img src = {articleImg}></img>
                    <img src = {calendar}></img>
                    <span>21 Jun 2022</span>
                    <img src = {comment}></img>
                    <span>5</span>
                    <img src = {person}></img>
                    <span>Chef Michael Carter</span>

                    <p>Why Fresh Food Matters</p>

                    <p>
                        Fresh ingredients mean better taste and healthier meals.
                        See why we never compromise on quality.
                    </p>

                    <span>Read More</span>
                </div>

                <div id = "categories">
                    <div id = "food">
                        <input type = "text" id = "search" placeholder = "Search articles..."></input>
                        <span id = "categoriesSpan">Categories</span>

                    <button id = "burger" className = "categories">
                        <span>Burgers</span>
                        <span>(7)</span>
                    </button>

                    <button id = "chicken" className = "categories">
                        <span>Chicken Meals</span>
                        <span>(9)</span>
                    </button>

                    <button id = "drinks" className = "categories">
                        <span>Drinks & Beverages</span>
                        <span>(3)</span>
                    </button>

                    <button id = "fries" className = "categories">
                        <span>Sides & Fries</span>
                        <span>(8)</span>
                    </button>

                    <button id = "sandwich" className = "categories">
                        <span>Sandwich</span>
                        <span>(3)</span>
                    </button>

                    <button id = "pizzaCat" className = "categories">
                        <span>Pizza</span>
                        <span>(5)</span>
                    </button>

                </div>

                <div id = "archive">
                    <span id = "archiveSpan">Archive</span>

                    <button id = "august" className = "categories">
                        <span>August 2025</span>
                        <span>(6)</span>
                    </button>

                    <button id = "july" className = "categories">
                        <span>July 2025</span>
                        <span>(1)</span>
                    </button>

                    <button id = "june" className = "categories">
                        <span>June 2025</span>
                        <span>(2)</span>
                    </button>
                    
                </div>
            </div>
            <FooterBlog/>
        </div>
        
    )
}

export default Blog;